/* eslint-disable react/jsx-pascal-case */
import { useQuery } from "@apollo/client";
import React, { useEffect, useRef, useState } from "react";

import { Table, RowsPerPageSelect } from "../../../components/Table";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import { amountFormat } from "../../../utils/amountFormat";

import Select from "react-select";
import DateFilter from "./DateFilter";
import { HiMiniXMark } from "react-icons/hi2";
import { CustomDropdownIndicator } from "../Settlement/Settlement";
import { GET_REFUND_REQUESTS } from "../../../Qurries";
import { endOfDay, startOfDay } from "date-fns";
import { Link, useLocation } from "react-router-dom";
import { IoSearchOutline } from "react-icons/io5";
import Pagination from "../../../components/Pagination/Pagination";
import { formatDate } from "../Transaction/components/TransactionDateFilter";
import { getStartAndEndOfMonth } from "../../../utils/getStartDateAndEndDate";
import { usePaymentUrlFilters } from "../../../hooks/usePaymentUrlFilters";
import { parseDateParam } from "../../../utils/paymentUrlFilters";
export enum refund_status {
  INITIATED = "INITIATED",
  APPROVED = "APPROVED",
  REJECTED = "REJECTED",
  DELETED = "DELETED BY USER",
  PROCESSING = "PROCESSING",
  AUTO_REFUND_INITIATED = "AUTO_REFUND_INITIATED",
}
function Refund() {
  const { get, getNumber, getBoolean, updateParams } = usePaymentUrlFilters();
  const location = useLocation();
  const skipUrlSyncRef = useRef(true);
  const refundReturnPath = `${location.pathname}${location.search}`;

  const [itemsPerRow, setItemsPerRow] = useState<{ name: number }>({
    name: getNumber("limit", 10),
  });
  const { startDate, endDate } = getStartAndEndOfMonth();
  const urlStartDate = parseDateParam(get("start_date"));
  const urlEndDate = parseDateParam(get("end_date"));
  const [currentPage, setCurrentPage] = useState(() => getNumber("page", 1));
  const [isDateRangeIsSelected, setIsDateRangeIsSelected] = useState(() =>
    getBoolean("custom_date"),
  );
  const [status, setStatus] = useState(() => get("status"));
  const [selectedRange, setSelectedRange] = useState({
    startDate: urlStartDate || new Date(),
    endDate: urlEndDate || new Date(),
    key: "selection",
  });
  const [searchText, setSearchText] = useState<string>(() => get("search"));
  const [appliedSearch, setAppliedSearch] = useState<string>(() =>
    get("search"),
  );


  const [refetchLoading, ] = useState(false);
  const [isCustomSearch, ] = useState(true);
  const {
    data: refundData,
    loading,
  } = useQuery(GET_REFUND_REQUESTS, {
    variables: {
      page: currentPage,
      limit: itemsPerRow.name,
      status: status,
      startDate: isDateRangeIsSelected? formatDate(selectedRange.startDate): startDate,
      endDate: isDateRangeIsSelected? formatDate(selectedRange.endDate): endDate,
      isCustomSearch: isCustomSearch,
      searchQuery: appliedSearch || null,
    },
    fetchPolicy: "network-only"
  });

  const [type, setType] = useState(() => get("date_range"));

  const [, setRefundRequestData] = useState<any>([]);

  useEffect(() => {
    skipUrlSyncRef.current = false;
  }, []);

  useEffect(() => {
    if (skipUrlSyncRef.current) return;

    updateParams({
      page: currentPage > 1 ? currentPage : null,
      limit: itemsPerRow.name !== 10 ? itemsPerRow.name : null,
      search: appliedSearch || null,
      status: status || null,
      start_date: isDateRangeIsSelected
        ? formatDate(selectedRange.startDate)
        : null,
      end_date: isDateRangeIsSelected
        ? formatDate(selectedRange.endDate)
        : null,
      custom_date: isDateRangeIsSelected ? true : null,
      date_range: type || null,
    });
  }, [
    currentPage,
    itemsPerRow.name,
    appliedSearch,
    status,
    isDateRangeIsSelected,
    selectedRange.startDate,
    selectedRange.endDate,
    type,
    updateParams,
  ]);

  const getReceiptLink = (order_id: string, school_id: string) => ({
    pathname: `/payments/transaction-receipt/${order_id}`,
    search: `?sid=${school_id}`,
    state: { from: refundReturnPath },
  });
  // const refetchFunction = useCallback(async ({
  //   status,
  //   page,
  //   limit,
  //   start_date,
  //   end_date,
  //   searchText,
  // }: {
  //   status?: string;
  //   start_date: any;
  //   end_date: any;
  //   page?: number;
  //   limit?: number,
  //   searchText?: string;
  // }) => {
  //   setRefetchLoading(true);
  //   const pageToUse = page !== undefined ? page : currentPage;
  //   try {
  //     await refetch({
  //       page: pageToUse,
  //       limit: limit,
  //       searchText: searchText,
  //       status: status,
  //       isCustomSearch: true,
  //       startDate: start_date,
  //       endDate: end_date,
  //     });
  //     setRefetchLoading(false);
  //   }  
  //   catch (error) {
  //     if (error) {
  //       setRefetchLoading(false);
  //     }
  //   }
  // }, [
  //   currentPage,
  //   refetch
  // ]);
  const handlePageChange = (page: any) => {
    setCurrentPage(page);
    // refetchFunction({
    //   page:page,
    //   limit:itemsPerRow.name,
    //   status: status,
    //   start_date: startDate,
    //   end_date: endDate,
    // });
  };

  // useEffect(() => {
  //   refetchFunction({
  //     status: status,
  //     start_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.startDate)
  //       : startDate,
  //     end_date: isDateRangeIsSelected
  //       ? formatDate(selectedRange.endDate)
  //       : endDate,
  //   });
  // }, [currentPage, itemsPerRow,  endDate,
  //   isDateRangeIsSelected,
  //   refetchFunction,
  //   selectedRange.endDate,
  //   selectedRange.startDate,
  //   startDate,
  //   status,
  // ]);
  return (
    <div className="w-full pt-2">
      {loading||refetchLoading ? (
        <div className="min-h-[80vh] w-full flex justify-center items-center">
          <AiOutlineLoading3Quarters className="text-3xl animate-spin" />
        </div>
      ) : (
        <>
          {refundData?.getRefundRequests?.refundRequests ? (
            <Table
              heading={"Refund"}
              loading={loading||refetchLoading}
              searchBox={
                <div className="w-full flex flex-col">
                  <div className="flex w-full items-center mb-2">
                    <div className="bg-[#EEF1F6] py-3 px-6 max-w-md w-full rounded-xl flex items-center justify-between">

  <input
    type="text"
    placeholder="Search(Institute Name,Order ID...)"
    value={searchText}
    onChange={(e) => setSearchText(e.target.value)}
    onKeyDown={(e) => {
      if (e.key === "Enter") {
        setAppliedSearch(searchText);
        setCurrentPage(1);
      }
    }}
    className="bg-transparent outline-none w-full text-sm placeholder:text-gray-400"
  />

  <div className="flex items-center gap-3">
    

    {searchText && (
      <HiMiniXMark
        className="cursor-pointer text-gray-500 text-lg"
        onClick={() => {
          setSearchText("");
          setAppliedSearch("");
          setCurrentPage(1);
        }}
      />
    )}


    <IoSearchOutline
      className="cursor-pointer text-[#1E1B59] text-lg"
      onClick={() => {
        setAppliedSearch(searchText);
        setCurrentPage(1);
      }}
    />

  </div>
</div>


                    <div className="flex justify-end items-center flex-1">
                      <DateFilter
                        originalData={
                          refundData?.getRefundRequests?.refundRequests
                        }
                        setRefundRequest={setRefundRequestData}
                        setType={setType}
                        type={type}
                        selectedRange={selectedRange}
                        setSelectedRange={setSelectedRange}
                        setIsDateRangeIsSelected={setIsDateRangeIsSelected}
                        refetch={() => {
                          setCurrentPage(1);
                        }}
                      />
                      <Select
                        className="font-normal m-0 p-2 capitalize"
                        options={[
                          {
                            label: "INITIATED",
                            value: refund_status.INITIATED,
                          },
                          { label: "REJECTED", value: refund_status.REJECTED },
                          { label: "APPROVED", value: refund_status.APPROVED },
                          {
                            label: "DELETED BY USER",
                            value: refund_status.DELETED,
                          },
                        ].map((status: any) => {
                          return {
                            label: status.label.toLowerCase(),
                            value: status.value,
                          };
                        })}
                        components={{
                          DropdownIndicator: CustomDropdownIndicator,
                          IndicatorSeparator: () => null,
                        }}
                        onChange={(e: any) => {
                          setCurrentPage(1);
                          setStatus(e.value);
                          // refetchFunction({
                          //   page:1,
                          //   limit:itemsPerRow.name,
                          //   status: e.value,
                          //   start_date: isDateRangeIsSelected
                          //     ? formatDate(selectedRange.startDate)
                          //     : startDate,
                          //   end_date: isDateRangeIsSelected
                          //     ? formatDate(selectedRange.endDate)
                          //     : endDate,
                          // });
                        }}
                        placeholder={
                          <div className="text-[#1E1B59] text-xs">Status</div>
                        }
                        value={null}
                        styles={{
                          control: (provided: any) => ({
                            ...provided,
                            backgroundColor: "#F6F8FA",
                            border: "1px solid #1B163B",
                            borderRadius: "6px",
                            width: "180px",
                            minHeight: "15px",
                            margin: "0px",
                            color: "#6687FF",
                          }),
                          valueContainer: (provided: any) => ({
                            ...provided,
                            padding: "0px",
                            paddingLeft: "0.5rem",
                          }),
                          input: (provided: any) => ({
                            ...provided,
                            backgroundColor: "transparent",
                            color: "#000",
                            "::placeholder": {
                              backgroundColor: "#YourDesiredColor",
                              opacity: 1,
                            },
                            placeholder: (provided: any) => ({
                              ...provided,
                              color: "red", // Set the color of the placeholder text
                            }),
                          }),
                        }}
                      />
                    </div>
                  </div>
                  <div>
                    <RowsPerPageSelect
                      setItemsPerRow={(e: any) => {
                        setCurrentPage(1);
                        setItemsPerRow(e);
                        // refetchFunction({
                        //   page:1,
                        //   limit:e.name,
                        //   status: status,
                        //   start_date: isDateRangeIsSelected
                        //     ? formatDate(selectedRange.startDate)
                        //     : startDate,
                        //   end_date: isDateRangeIsSelected
                        //     ? formatDate(selectedRange.endDate)
                        //     : endDate,
                        // });
                      }}
                      itemsPerRow={itemsPerRow}
                      className=" justify-start"
                    />
                  </div>
                  <div className="flex items-center">
                    {type !== "" && (
                      <div className=" text-sm m-2  max-w-fit ">
                        <button
                          onClick={() => {
                            setIsDateRangeIsSelected(false);
                            setCurrentPage(1);
                            setSelectedRange({
                              startDate: startOfDay(new Date()),
                              endDate: endOfDay(new Date()),
                              key: "selection",
                            });
                            setType("");
                            // refetchFunction({
                            //   page:1,
                            //   limit:itemsPerRow.name,
                            //   status: status,
                            //   start_date: startDate,
                            //   end_date: endDate,
                            // });
                          }}
                          className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                        >
                          {type} <HiMiniXMark className=" text-lg ml-1" />
                        </button>
                      </div>
                    )}
                    {status !== "" && (
                      <div className=" text-sm m-2  max-w-fit ">
                        <button
                          onClick={() => {
                            setStatus("");
                            setCurrentPage(1);
                            // refetchFunction({
                            //   page:1,
                            //   limit:itemsPerRow.name,
                            //   start_date: isDateRangeIsSelected 
                            //   ? formatDate(selectedRange.startDate) 
                            //   : startDate, 
                            //   end_date: isDateRangeIsSelected 
                            //   ? formatDate(selectedRange.endDate) 
                            //   : endDate,
                            // });
                          }}
                          className="bg-[#6687FFCC] font-medium flex items-center rounded-lg text-white px-4 py-2 h-full w-full"
                        >
                          {status} <HiMiniXMark className=" text-lg ml-1" />
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              }
              copyContent={[2, 3]}
              data={[
                [
                  "Sr.No",

                  "Refund ID",
                  "Order ID",
                  "Refund Amount",
                  "Order Amount",
                  "Transaction Amount",
                  "Status",
                  "Created Date",
                  "Updated Date",
                  "Reason",
                ],
                ...([
                  ...refundData?.getRefundRequests?.refundRequests.map(
                    (data: any, index: number) => {
                      return {
                        ...data,
                        serialNumber:
                          (currentPage - 1) * itemsPerRow.name + 1 + index,
                      };
                    }
                  ),
                ]
                  .map((data: any) => [
                    <div>{data.serialNumber}</div>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                      >
                      <div className="truncate max-w-[10rem]">{data._id}</div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">{data.order_id}</div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">
                        {amountFormat(data.refund_amount)}
                      </div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">
                        {amountFormat(data.order_amount)}
                      </div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">
                        {amountFormat(data.transaction_amount)}
                      </div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">
                        {data.status !== "APPROVED"
                          ? data.status
                          : "PROCESSED/APPROVED"}
                      </div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">
                        {new Date(data?.createdAt).toLocaleString("hi")}
                      </div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate">
                        {new Date(data?.updatedAt).toLocaleString("hi")}
                      </div>
                    </Link>,
                    <Link
                      to={getReceiptLink(data?.order_id, data.school_id)}
                      state={{ from: refundReturnPath }}
                    >
                      <div className="truncate max-w-[7rem]"
                        title={data?.reason || "NA"}
                        style={{ position: "relative" }}
                        >{data?.reason || "NA"}</div>
                    </Link>,
                  ]) || []),
              ]}
              footer={
                <div className="flex justify-center items-center">
                  <Pagination
                    currentPage={currentPage}
                    totalPages={Math.ceil(
                      refundData?.getRefundRequests?.totalPages
                    )}
                    onPageChange={handlePageChange}
                  />
                </div>
              }
            />
          ) : (
            <>{null}</>
          )}
        </>
      )}
    </div>
  );
}

export default Refund;